export default __webpack_public_path__ + "static/media/russia.4f27b8a0.svg";